import { Field } from "react-final-form";
import { Row, Col } from "react-bootstrap";

import BMXSeparator from "../../../../../../Components/Separator/BMXSeparator";
import BMXTextField from "../../../../../../Components/Inputs/BMXTextField/BMXTextField";

import "./ServiceRealizationFormStepOne.scss";

import { useTranslation } from "react-i18next";

const ServiceRealizationFormStepTwo = ({ values, form, initialValues }) => {
  const { t } = useTranslation();

  return (
    <div style={{ marginTop: 8 }}>
      <BMXSeparator title="LICZNIKI" />
      <Row>
        <Col xs={4}>
          <Field name="counter1" component={BMXTextField} label="Licznik 1" />
        </Col>
        <Col xs={4}>
          <Field name="counter2" component={BMXTextField} label="Licznik 2" />
        </Col>
        <Col xs={4}>
          <Field name="counter3" component={BMXTextField} label="Licznik 3" />
        </Col>
      </Row>
      <Row>
        {" "}
        <Col>
          {" "}
          <Field
            name="technicianNotesNextIntervention"
            component={BMXTextField}
            label="Uwagi technika do kolejnej interwencji"
            multiline
          />{" "}
        </Col>{" "}
      </Row>{" "}
    </div>
  );
};

export default ServiceRealizationFormStepTwo;
